import { Injectable } from '@angular/core';
import { RequestTypeTranslation } from '../model/requestType.enum';
import i18next from 'i18next';
import RequestSubtype from '../model/requestSubtype.enum';
import {
  JudgementsStatus,
  RedPlatesStatus,
  RequestStatus
} from '../model/requestStatus.enum';
import { LoanOptions } from '../model/loanRequest.enum';
import { PetitionerType } from '../model/petitionerType.enum';
import { UseOptions } from '../model/didactic.enum';
import { ProjectType } from '../model/projectType.enum';
import { CampaignRaffleStatus, CampaignTypes } from '../model/campaign.enum';
import { LeasingStatusDocs } from '../model/leasing.enum';

@Injectable({
  providedIn: 'root'
})
export class Translate {
  translateRequestTypes(requestType: string) {
    switch (requestType) {
      case 'ENDOWMENT':
        return RequestTypeTranslation.dot;
      case 'LEASING':
        return RequestTypeTranslation.leasing;
      case 'EMPLOYEE_LEASING':
        return RequestTypeTranslation.employeeLeasing;
      case 'ENDOWMENT_LEASING':
        return RequestTypeTranslation.dotArr;
      case 'CAMPAIGN':
        return RequestTypeTranslation.campaigns;
      case 'FUNCTION':
        return RequestTypeTranslation.function;
      case 'PROVISIONAL':
        return RequestTypeTranslation.provisional;
      case 'PROJECT':
        return RequestTypeTranslation.proyect;
      case 'GENERAL_SERVICES':
        return RequestTypeTranslation.generalServices;
      case 'EDUCATIONAL':
        return RequestTypeTranslation.didactic;
      case 'INNER_ROUTE':
        return RequestTypeTranslation.innerRoute;
      case 'LOAN':
        return RequestTypeTranslation.loan;
      case 'JUDGEMENTS':
        return RequestTypeTranslation.judgements;
      case 'TRANSFERS':
        return RequestTypeTranslation.transfers;
      case 'RED_PLATES':
        return RequestTypeTranslation.redPlates;
      case 'E-S':
        return RequestTypeTranslation.es;
      default:
        return i18next.t('noData');
    }
  }

  translateRequestStatus(status: string): string {
    switch (status) {
      case RequestStatus.NEW_REQUEST:
        return i18next.t('newRequest');
      case RequestStatus.PENDING_APPROVAL:
        return i18next.t('pendingApproval');
      case RequestStatus.APPROVED:
        return i18next.t('approved');
      case RequestStatus.SENT_TO_FACTORY:
        return i18next.t('sentToFactory');
      case RequestStatus.IN_PRODUCTION:
        return i18next.t('production');
      case RequestStatus.PENDING_REGISTRATION:
        return i18next.t('pendingRegistration');
      case RequestStatus.REGISTERED:
        return i18next.t('registered');
      case RequestStatus.PENDING_ASSIGNMENT:
        return i18next.t('pendingAssignment');
      case RequestStatus.PENDING_EXPEDITION:
        return i18next.t('pendingExpedition');
      case RequestStatus.IN_EXPEDITION:
        return i18next.t('expedition');
      case RequestStatus.IN_EXPEDITION_FACTORY:
        return i18next.t('expeditionFactory');
      case RequestStatus.PENDING_PICK_UP:
        return i18next.t('pickUp');
      case RequestStatus.ACTIVE:
        return i18next.t('activated');
      case RequestStatus.CLOSED_REQUEST:
        return i18next.t('closedRequest');
      case RequestStatus.CANCELLED:
        return i18next.t('cancelled');
      case RequestStatus.REJECTED:
        return i18next.t('authStatusRejected');
      case RedPlatesStatus.ADMINISTRATIVE_PROCESSING:
        return i18next.t('administrativeProcessing');
      case RedPlatesStatus.ACTIVE:
        return i18next.t('active');
      case RedPlatesStatus.PENDING_RETURN:
        return i18next.t('pendingReturn');
      case RedPlatesStatus.RETURNED:
        return i18next.t('return');
      case JudgementsStatus.PENDING_QUALITY:
        return i18next.t('pendingQuality');
      case JudgementsStatus.PENDING_AUTHORIZATION:
        return i18next.t('pendingAuth');
      case JudgementsStatus.EXEC_AUTHORIZATION:
        return i18next.t('execAuth');
      case JudgementsStatus.PENDING_GROUPPING:
        return i18next.t('pendingGroup');
      case JudgementsStatus.PENDING_SEND_TO_REC:
        return i18next.t('pendingSendToRec');
      case JudgementsStatus.PENDING_CERTIFIED:
        return i18next.t('pendingCertificate');
      case JudgementsStatus.PENDING_INSURANCE:
        return i18next.t('pendingInsurance');
      case JudgementsStatus.FINISHED:
        return i18next.t('finished');
      default:
        return i18next.t('noData');
    }
  }

  translateAuthorizationsStatus(status: string) {
    switch (status) {
      case 'Pending':
        return i18next.t('authStatusPending');
      case 'Pending Approval':
        return i18next.t('pendingApproval');
      case 'Rejected':
        return i18next.t('authStatusRejected');
      case 'Accepted':
        return i18next.t('authStatusAccepted');
      default:
        return i18next.t('noData');
    }
  }
  translateRequestSubtypes(requestSubtype: string) {
    switch (requestSubtype) {
      case 'SUBSTITUTION':
        return RequestSubtype.REPLACEMENT;
      case 'FIRST_ASSIGNMENT':
        return RequestSubtype.FIRSTASSIGNMENT;
      case 'LONG_DURATION':
        return LoanOptions.LD;
      case 'CARPOOL':
        return LoanOptions.CP;
      case 'WEDDING':
        return LoanOptions.W;
      case UseOptions.I:
        return i18next.t('internal');
      case UseOptions.E:
        return i18next.t('donation');
      default:
        return i18next.t('noData');
    }
  }

  translateRetribution(retribution: string) {
    switch (retribution) {
      case 'PRIMARY':
        return i18next.t('primaryRE');
      case 'SECONDARY':
        return i18next.t('secondaryRE');
      default:
        return i18next.t('noData');
    }
  }

  translateDriverType(type: string) {
    switch (type) {
      case 'EXTERNAL':
        return i18next.t('external');
      case 'INTERNAL':
        return i18next.t('internal');
      default:
        return i18next.t('noData');
    }
  }

  translateRequestListTypes(type: string) {
    switch (type) {
      case 'requests':
        return i18next.t('requests');
      case 'judgements':
        return i18next.t('judgements');
      case 'transfers':
        return i18next.t('transfers');
      case 'redplates':
        return i18next.t('redPlate');
      case 'es':
        return 'E/S';
      default:
        return i18next.t('noData');
    }
  }

  translateLoanTypes(type: string) {
    switch (type) {
      case LoanOptions.LD:
        return 'LONG_DURATION';
      case LoanOptions.CP:
        return 'CARPOOL';
      case LoanOptions.W:
        return 'WEDDING';
      case 'LONG_DURATION':
        return 'LONG_DURATION';
      case 'CARPOOL':
        return 'CARPOOL';
      case 'WEDDINGS':
        return 'WEDDING';
      default:
        return i18next.t('noData');
    }
  }

  translateForWhom(type: string) {
    switch (type) {
      case PetitionerType.SEAT:
        return i18next.t('bookEmployee');
      case PetitionerType.EXT:
        return i18next.t('bookExtern');
      case PetitionerType.FAM:
        return i18next.t('bookFamiliar');
      default:
        return i18next.t('noData');
    }
  }

  translateProjects(text: string) {
    switch (text) {
      case ProjectType.NEW:
        return i18next.t('gsOriginNew');
      case ProjectType.REGU:
        return i18next.t('summaryQuotaRegularization');
      case ProjectType.OTHER:
        return i18next.t('otherBrands');
      case 'PROTOTYPE':
        return i18next.t('prototype');
      case 'PRESERIE':
        return i18next.t('preseries');
      case 'PRE_PRESERIE':
        return i18next.t('prePreseries');
      case 'SERIE':
        return i18next.t('series');
      case 'ZEROSERIE':
        return i18next.t('series0');
      case 'PRESS':
        return i18next.t('pressAndSalons');
      case 'SUBSTITUTION':
        return i18next.t('substitution');
      case 'ADDITIONAL':
        return i18next.t('additional');
      case 'DEVELOPMENT':
        return i18next.t('developmentSeries');
      case 'MISCELLANEOUS':
        return i18next.t('variousSeries');
      case 'CARRIAGE':
        return i18next.t('bodywork');
      case 'VEHICLE':
        return i18next.t('vehicle');
      case 'VFF':
        return i18next.t('VFF');
      case 'PVS':
        return i18next.t('PVS');
      case 'EMPTY':
        return i18next.t('NA');
      case 'BASE_PROJECT':
        return i18next.t('baseProject');
      case 'PA':
        return i18next.t('PA');
      case 'MY/MP (MODELPFLEGE)':
        return 'MY/MP (MODELPFLEGE)';
      default:
        return i18next.t('noData');
    }
  }

  translateCampaignType(type: string) {
    switch (type) {
      case CampaignTypes.RAFFLE:
        return i18next.t('raffle');
      case CampaignTypes.STANDARD:
        return i18next.t('standard');
      case 'LEASING':
        return i18next.t('leasing');
      case 'ENDOWMENT':
        return i18next.t('endowment');
      default:
        return i18next.t('noData');
    }
  }

  translateCampaignRaffleStatus(status: string) {
    switch (status) {
      case CampaignRaffleStatus.NOT:
        return i18next.t('notAssigned');
      case CampaignRaffleStatus.ASSIGNED:
        return i18next.t('assigned');
      case CampaignRaffleStatus.DECLINED:
        return i18next.t('declined');
      case CampaignRaffleStatus.PENDING:
        return i18next.t('pendingValidation');
      default:
        return i18next.t('noData');
    }
  }

  translateStatusDocs(status: string) {
    switch (status) {
      case LeasingStatusDocs.IN_REVIEW:
        return i18next.t('inReview');
      case LeasingStatusDocs.VALIDATED:
        return i18next.t('validated');
      case LeasingStatusDocs.PENDING_UPLOAD:
        return i18next.t('pendingUpload');
      default:
        return i18next.t('noData');
    }
  }
}
